import type { FC } from "react";
import type { CampaignLifecycleStatus } from "@/layouts/AppLayout/campaignLifecycle";
import { TEXT } from "@/constants/text";
import styles from "@/pages/CampaignOverviewPage/page/CampaignOverviewHeader.module.css";

interface CampaignOverviewHeaderProps {
  title: string;
  status?: CampaignLifecycleStatus;
  subtitleParts: string[];
}

const BADGE_LABEL: Record<CampaignLifecycleStatus, string> = {
  active: TEXT.campaignOverview.badgeActive,
  ended: TEXT.campaignOverview.badgeEnded,
  upcoming: TEXT.campaignOverview.badgeUpcoming,
};

const BADGE_CLASS: Record<CampaignLifecycleStatus, string> = {
  active: styles.badgeActive,
  ended: styles.badgeEnded,
  upcoming: styles.badgeUpcoming,
};

const CampaignOverviewHeader: FC<CampaignOverviewHeaderProps> = ({
  title,
  status,
  subtitleParts,
}) => (
  <header className={styles.header}>
    <div className={styles.titleRow}>
      <h2 className={styles.title}>{title}</h2>
      {status && (
        <span className={`${styles.badge} ${BADGE_CLASS[status]}`}>
          {BADGE_LABEL[status]}
        </span>
      )}
    </div>
    <p className={styles.subtitle}>{subtitleParts.join(" · ")}</p>
  </header>
);

export default CampaignOverviewHeader;
